import {qs} from '@shared/helpers/queryString'

import {OrderSheetPageSet, OrderSheetPageSetType} from '@web/core/constants'
import getApi, {createWrapper} from '@web/helpers/api'

import {MembershipQuickJoinResponse} from './interfaces'

const api = getApi(`/orderApi`)

const OrderSheetApiUrlInfo = {
    v1: `/orderSheet/mall/id/v1`,
    v2: `/orderSheet/mall/id/v2`,
}

const ApiUrlInfo = {
    [OrderSheetPageSet.MALL]: {
        /** 맴버십 퀵조인 */
        membershipJoin: '/orderSheet/mall/memberships/join',
    },
    [OrderSheetPageSet.EASYBOOKING]: {
        /** 맴버십 퀵조인 */
        membershipJoin: '/orderSheet/easyBooking/memberships/join',
    },
    [OrderSheetPageSet.SELLER]: {
        /** 맴버십 퀵조인 */
        membershipJoin: '/orderSheet/seller/memberships/join',
    },
    // 패밀리 결제는 이미 맴버십을 가입했기 때문에, 퀵조인이 필요 없습니다.
    [OrderSheetPageSet.FAMILY_PAY]: {
        membershipJoin: '',
    },
    // 클레임은 맴버십 퀵조인이 필요 없습니다.
    [OrderSheetPageSet.CLAIM]: {
        membershipJoin: '',
    },
}

/** 주문 경로 V1 */
async function registerOrderV1(registerOrderKey: string, merchantId: string) {
    const url = OrderSheetApiUrlInfo.v1
    return createWrapper<{orderSheetId: string}>(api.get(url, {params: {registerOrderKey, merchantId}}))
}

/** 주문 경로 V2 */
async function registerOrderV2(registerOrderKey: string, merchantNo: string) {
    const url = OrderSheetApiUrlInfo.v2
    return createWrapper<{orderSheetId: string}>(api.get(url, {params: {registerOrderKey, merchantNo}}))
}

/** 맴버십 퀵조인 */
async function fetchMembershipQuickJoin({
    isAgreeAd,
    pageSet,
}: {
    /** 동의 여부 */
    isAgreeAd: boolean
    pageSet: OrderSheetPageSetType
}) {
    const url = ApiUrlInfo[pageSet].membershipJoin
    return createWrapper<MembershipQuickJoinResponse>(
        api.post(
            qs.stringifyUrl({
                url,
                query: {
                    isAgreeAd,
                },
            }),
        ),
    )
}

export default {
    registerOrderV1,
    registerOrderV2,
    fetchMembershipQuickJoin,
}
